import { QueryClient, UseMutationResult } from 'react-query';
import { getVenueBrandingByIdApi, updateVenueBrandingApi, applyBrandingToVenuesApi } from '../constants/apiEndPoints';
import { _HttpMethods, _Payload } from '../constants/staticTypes';
import HttpServiceHelper from './httpServiceHelper';
import { AxiosResponse } from 'axios';
import { getErrorMessage } from '../utils/common';
import { AlertVariant } from '../constants/constants';

export const getVenueSettings = (queryClient: QueryClient, xTenantId?: string) => {
    let url = `${getVenueBrandingByIdApi}`;

    return HttpServiceHelper({
        url,
        method: _HttpMethods.POST,
        queryClient,
        data: {
            id: xTenantId,
        },
    });
};

export type _UpdateSettingsData = {
    id?: string;
    webLogo: string | null;
    mobileLogo: string | null;
    primaryColor: string;
    secondaryColor: string;
};

export type _ApplyToVenuesData = {
    id: string;
    applyToAllVenues: boolean;
    venueIds?: string[];
};

export const updateVenueSettings = (
    addAdminOrgPermissionMutation: UseMutationResult<AxiosResponse<any, any>, unknown, _Payload, unknown>,
    param: _UpdateSettingsData,
    onSuccess: (data: any) => void,
    onError: (res: string, variant: string) => void
) => {
    addAdminOrgPermissionMutation.mutate(
        {
            url: updateVenueBrandingApi,
            method: _HttpMethods.POST,
            data: param,
        },
        {
            onSuccess: (res) => onSuccess(res.data),
            onError: (res) => onError(getErrorMessage(res), AlertVariant.ERROR),
        }
    );
};

export const applyBrandingToVenues = (
    applyBrandingMutation: UseMutationResult<AxiosResponse<any, any>, unknown, _Payload, unknown>,
    param: _ApplyToVenuesData,
    onSuccess: (data: any) => void,
    onError: (res: string, variant: string) => void
) => {
    applyBrandingMutation.mutate(
        {
            url: applyBrandingToVenuesApi,
            method: _HttpMethods.POST,
            data: param,
        },
        {
            onSuccess: (res) => onSuccess(res.data),
            onError: (res) => onError(getErrorMessage(res), AlertVariant.ERROR),
        }
    );
};
